import { Textarea, TextInput } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import ReportVesselInputs from "src/components/pages/Management/Reports/ReportVesselInputs";
import useIsFleet from "src/components/pages/Management/useIsFleet";
import useGetAllYachts from "src/components/pages/Management/Yachts/useGetAllYachts";
import ReportInputs from "src/components/pages/Reports/AddReport/ReportInputs";
import CheckboxGroup from "src/components/shared/_FormInputs/CheckboxGroup/CheckboxGroup";
import type { RecursiveSelectItem } from "src/components/shared/_FormInputs/CheckboxGroup/checkboxGroup.utils";
import Select from "src/components/shared/_FormInputs/Select";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import { useGetApi } from "src/hooks";
import {
  AddReportContainer,
  LayoutReportContainer,
} from "src/pages/Reports/AddReport/AddReport.styled";
import { ButtonsWrapper, Divider, Flex, PageContainer } from "src/styled";

const AddVesselReport = () => {
  const { yachts } = useGetAllYachts();
  const [, setStartDate] = useState("");
  const [, setEndDate] = useState("");
  const isFleet = useIsFleet();
  const parsedYachts = useMemo((): RecursiveSelectItem[] => {
    const mapped = yachts.map((yacht: any) => ({
      label: yacht.yachtname,
      value: yacht.yid,
      group: yacht.clientname,
    }));
    return [{ label: "All", value: "*", group: "All" }, ...mapped];
  }, [yachts]);

  const { data } = useGetApi({
    request: "get-report",
    // mapper: mapData,
    fetchOnInit: false,
  });

  const methods = useForm({
    defaultValues: {
      name: "",
      desc: "",
      against: "0",
      vessel: {
        type: "0",
        status: "0",
        vessels: [],
        fields: [],
        dates: "",
        start: null,
        end: null,
      },
      logbooks: {
        type: "0",
        status: "0",
        vessels: [],
        dates: "",
        start: null,
        end: null,
        logbook: [{ label: "All", value: "*" }],
      },
    },
  });

  const { watch, handleSubmit, control, register, reset, setValue } = methods;
  const against = watch("against");
  useEffect(() => {
    reset();
    setValue("against", against);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset form when against changes
  }, [against]);

  const handleCreateReport = (data: any) => {
    console.log(data);
  };

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleCreateReport)}>
          <Breadcrumbs border={false}>
            <ButtonsWrapper>
              <Button type="submit">Save</Button>
            </ButtonsWrapper>
          </Breadcrumbs>

          <AddReportContainer>
            <LayoutReportContainer style={{ padding: 20 }}>
              <Flex gap="xl">
                <TextInput {...register("name")} label="Report Name" />
                <Textarea
                  label="Description"
                  placeholder="Report description"
                  autosize={false}
                  minRows={2}
                  {...register("desc")}
                />
                <Select
                  control={control}
                  name="against"
                  maw={"200px"}
                  label="Report Against"
                  data={[
                    {
                      value: "0",
                      label: "Vessel",
                    },
                    {
                      value: "1",
                      label: "Logbooks",
                    },
                  ]}
                />
              </Flex>

              <Divider style={{ margin: 10, opacity: 0.3 }} />
              {against === "0" ? (
                <ReportVesselInputs
                  methods={methods}
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  yachts={parsedYachts}
                />
              ) : (
                <Flex>
                  <Flex style={{ flex: 2 }}>
                    <ReportInputs
                      data={data}
                      prefix="logbooks"
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      methods={methods}
                      hideNameAndDesc
                      disableL10
                    />
                  </Flex>

                  <div style={{ flex: 1 }}>
                    <CheckboxGroup
                      name="vessel.vessels"
                      title="Vessels"
                      control={control}
                      data={parsedYachts}
                      disabled={false}
                      grouped={!isFleet}
                    />
                  </div>
                </Flex>
              )}
            </LayoutReportContainer>
          </AddReportContainer>
        </form>
      </FormProvider>
    </PageContainer>
  );
};
export default AddVesselReport;
